// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.redirect-button[data-v-fb6ac390] {\n  margin-top: 20px; /* Üstten boşluk */\n  margin-left: 20px; /* Soldan boşluk */\n}\n", ""]);
// Exports
module.exports = exports;
